
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review-guidelines",
      function () {
        return require("private-next-pages/review-guidelines.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/review-guidelines"])
      });
    }
  